import styled from 'styled-components'
import { space, style } from 'styled-system'

const fill = style({
  prop: 'fill',
  key: 'colors'
})

export const SVG = styled.svg`
  ${space}
`

export const Path = styled.path`
  ${fill}
`
